import { getCurrentInstance } from 'vue'

/**
 * Expose component methods to instance proxy
 */
export function useExpose(apis) {
  const instance = getCurrentInstance()
  if (instance) {
    Object.assign(instance.proxy, apis)
  }
}
